import $ from 'gridstrap/lib/gs-zepto';

export class GSFormOptionList {

	//
	// Properties
	//

	private root;
	private content;
	private checkboxes;

	//////////

	get isOverflow() { return this.root.hasClass('is-overflow'); }
	set isOverflow(value) { this.root.toggleClass('is-overflow', value); }

	get isPopulated() { return this.root.closest('.gs-Wizard-step').hasClass('is-populated'); }
	set isPopulated(value) { this.root.closest('.gs-Wizard-step').toggleClass('is-populated', value); }

	//
	// Methods
	//

	checkIfPopulated() {
		let checked = this.checkboxes.filter(':checked');
		this.isPopulated = checked.length > 0;
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.content = this.root.find('.gs-FormOptionList-content');
		this.checkboxes = this.root.find('.gs-FormOption--checkbox input');
		this.checkboxes.on('click', () => this.checkIfPopulated());
	}

	gsOnWindowResize() {
		let containerHeight = this.root.height();
		let contentHeight = this.content.height();
		this.isOverflow = (contentHeight > containerHeight);
	}
}
